import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'IssueFormAlternativeIdController',
            IssueFormAlternativeIdController
        );

    function IssueFormAlternativeIdController() {
        init();

        function init() {}
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/alternative-id/alternative-id.controller.ts